module.exports = __webpack_public_path__ + "static/media/5.843aa143.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/vitebsk/5.jpg
// module id = 252
// module chunks = 0